import { Global, Collection, Jobs } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../components/SeoHead';
import LatestAwards from '../../components/LatestAwards';
import LatestNews from '../../components/LatestNews';
import MainBanner from '../../components/MainBanner';
import LatestJobs from '../../components/LatestJobs';
import ImageWithVideoBanner from '../../components/ImageWithVideoBanner';
import MultiColumnCTA from '../../components/MultiColumnCTA';

export default function Home({
    global,
    all_awards,
    all_news,
    all_jobs,
    all_solutions,
    all_specialisms
}) {
    return (
        <>
            <SeoHead
                site_name={`Lorien | United States`}
                page_name={`The global house of tech and transformation recruitment | Lorien | United States`}
                en_gb={false}
                en_us={true}
            />
            <MainBanner
                global={global}
                pathPrefix={``}
                customClass={``}
                content={
                    <>
                        <h1>We are the house of global<br></br> tech recruitment</h1>
                        <p>Lorien is a digital, transformation and technology recruitment specialist. We work with clients of all sectors, sizes, and tech needs–from digital giants to tech-enabled businesses–to attract and retain top talent around the world. Through our network of specialists, we combine deep tech sector expertise with the scope, depth, and breadth of large-scale talent solutions, giving our clients the confidence and the agility to compete in the digital age.</p>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner-v2.png`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/main-banner-overlay-v2.png`}
                imageALT2={`Overlay Main Banner`}
                jobSearch={true}
                pageAnchor={`more-info-of-us`}
                locale={`/us`}
            />
            <ImageWithVideoBanner
                global={global}
                pathPrefix={`us.homepage.image_with_video_banner`}
                customClass={`py-5`}
                content={<>
                    <h2>It's What We Do</h2>
                </>
                }
                buttonTitle={`Learn More About What We Do`}
                buttonLink={`/`}
                videoLink={`https://www.youtube.com/watch?v=rKka_IEN_4s`}
                bannerImage={``}
                imageURL={`/site-assets/images/what-we-do.jpg`}
                imageALT={`It's what we do`}
                videoGalleryClass={`WhatWeDo`}
                sectionId={`what-we-do`}
                pageAnchor={`more-info-of-us`}
            />
            <LatestJobs
                global={global}
                pathPrefix={`us.homepage.latest_jobs`}
                customClass={`py-5`}
                post={all_jobs}
                content={<>
                    <h2>Hot Jobs</h2>
                    <p>Find the best tech and digital career opportunities.</p>
                </>
                }
                buttonTitle={`View All Jobs`}
                buttonLink={`/us/jobs/`}
                swiperID={`latestJobsSwiper`}
                locale={`https://www.lorienglobal.com/us`}
            />
            <MultiColumnCTA
                global={global}
                pathPrefix={`us.homepage.multi_column_cta`}
                customClass={`py-5`}
                sectionId={`more-info-of-us`}
                left_content={
                    <>
                        <h2>Market's We Recruit</h2>
                    </>
                }
                right_content={
                    <>
                        <h2>Business Solutions</h2>
                    </>
                }
                left_post={all_specialisms}
                right_post={all_solutions}
                leftColumnFilterUrl={`us/markets/`}
                rightColumnFilterUrl={`us/employers/`}
            />
            <LatestNews
                global={global}
                pathPrefix={`us.homepage.latest_news`}
                customClass={`py-5`}
                post={all_news}
                content={
                    <>
                        <h2>The Lorien Pulse: Latest News, Events, and Insights</h2>
                        <p>Our tech expertise and partner-led approach allows us to deliver highly successful results for our clients so they can attract and retain unique talent for their business. Explore our latest collection of case studies, news, events, and insights</p>
                    </>
                }
                buttonLink={`/us/insights/`}
                buttonTitle={`View All Insights`}
                locale={`us/`}
            />
            <LatestAwards
                global={global}
                pathPrefix={`us.homepage.latest_awards`}
                customClass={`pt-5`}
                content={
                    <>
                        <h2>Awards & Industry Recognition</h2>
                    </>
                }
                post={all_awards}
                buttonLink={``}
                buttonTitle={``}
                swiperID={`latestAwardsSwiper`}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const awards = await Collection('awards_industry_recognition');
    const solutions = (await Collection("employers")).filter(function (post) {
        return post.region?.en.includes("United States");
    });
    const specialisms = (await Collection("specialisms")).filter(function (post) {
        return post.region?.en.includes("United States");
    });

    const news = (await Collection('news'))
        .filter(function (post) {
            return (
                post.country?.en == "United States" || post.country?.en == "All"
            );
        });

    const all_jobs = (await Jobs())
        .filter(function (job) {
            return (
                job.categories
                    .find((cat) => cat.id === "7710db30-b4cf-4029-b846-e02e2f0c9b3b" && cat.values.find((x) => x.name === "United States"))
            );
        })
        .filter(function (job) {
            return (
                (new Date(job?.expires_at)) >= (new Date())
            )
        })
        .getItems().slice(0, 8);
        
    const all_solutions = solutions.orderBy('order').getItems();
    const all_specialisms = specialisms.orderBy("order").getItems();
    const all_awards = awards.orderBy('order').getItems();
    const all_news = news.orderBy('date').getItems().slice(0, 8);

    return {
        props: {
            global,
            all_awards,
            all_news,
            all_jobs,
            all_solutions,
            all_specialisms
        }
    };
}
